
document.addEventListener("DOMContentLoaded", function(event) {  
    console.log('volumeNotice');

    var inputs = document.getElementsByClassName("quantity__input");

    // for all inputs
    for (var i = 0; i < inputs.length; i++) {

        // initialize 
        var id = inputs[i].getAttribute("data-id");
        const volumeWrapper = document.querySelector("[data-id='volumes_"+id+"']");
        
        setVolumeNotice(inputs[i].value, volumeWrapper);
                
        if(!inputs[i].classList.contains('quantity__input__cart')) {

            // event on input change
            inputs[i].addEventListener('change', function (evt) {
                console.log('change');
                var value = evt.target.value;
                var id = evt.target.getAttribute("data-id");
                const volumeWrapper = document.querySelector("[data-id='volumes_"+id+"']");

                console.log(id);
                setVolumeNotice(value, volumeWrapper);
            
            });

        }

    }


});

function setVolumeNotice(value, volumeWrapper) {
    console.log(volumeWrapper);
    var volumeNotices = volumeWrapper.getElementsByClassName("volumeNotice");
    console.log(volumeNotices);

    // deactivate old active 
    volumeWrapper.classList.remove("vis");
    
    for (let index = 0; index < volumeNotices.length; index++) {
       volumeNotices[index].classList.remove('vis');    
    }


    var oneVis = false;

    for (var a = 0; a < volumeNotices.length; a++) {

        var from = volumeNotices[a].getAttribute("data-from");
        var to = volumeNotices[a].getAttribute("data-to");

        console.log(volumeNotices[a]);
        console.log(value);
        console.log('from ',from);
        console.log('to ',to);

        if(value >= parseInt(from) && to != 'unlimited' && value <= parseInt(to) || value >= parseInt(from) && to == 'unlimited' ) {
            oneVis = true;
                            
            volumeNotices[a].classList.add("vis");
            break;
        }
    }
    

    if( oneVis == true ) {        
        volumeWrapper.classList.add("vis");
    } else {
        volumeWrapper.classList.remove("vis");
    }
} 

// UPDATE on Quantity change in cart
document.addEventListener("cart:updated", (event) => {

    const cartWrapper = document.getElementById("CartDrawer");
    var inputs = cartWrapper.getElementsByClassName("quantity__input");

    for (var i = 0; i < inputs.length; i++) {
        var id = inputs[i].getAttribute("data-id");
        const volumeWrapper = document.querySelector("[data-id='volumes_"+id+"']");
        
        setVolumeNotice(inputs[i].value, volumeWrapper);
    }
});